import actions from '@/core/store/documentos/actions'
import state from '@/core/store/documentos/state'
import mutations from '@/core/store/documentos/mutations'

export default {
	actions,
	state,
	mutations,
}
